import { useState, useEffect } from "react";
import { dbURL } from "./global";

async function getErrorItems() {
  const address = dbURL + "load.php";
  const options = {
    method: "GET",
    mode: "cors",
    credentials: "include",
  };
  const response = await fetch(address, options);
  const result = await response.json();

  return result;
  /*return fetch(address, options
    )
    .then(response => response.json())
    .then(result => {
        return result
    })*/
}

function UseErrorItems(update) {
  const [errorItems, setErrorItems] = useState([]);

  useEffect(() => {
    getErrorItems().then((items) => {
      setErrorItems(items);
    });
  }, [update]);

  return errorItems;
}

export default UseErrorItems;
